import { HackathonHomeRouteComponent as HackathonHome } from './HackathonHome';
export default HackathonHome;
